import { z } from 'zod';

export const API_URL = (import.meta.env.VITE_API_URL ?? window.location.origin).replace(/\/+$/, '');

const runtimeConfigSchema = z.object({
  network: z.enum(['mainnet', 'testnet']),
  manifestUrl: z.string(),
  explorerUrl: z.string(),
  domainMarketUrl: z.string(),
  botUrl: z.string(),
  publishAmountTon: z.string(),
  limits: z.object({
    maxBundleBytes: z.number(),
    maxAssetBytes: z.number(),
    maxFilesPerSite: z.number(),
  }),
});

export type RuntimeConfig = z.infer<typeof runtimeConfigSchema>;

export async function fetchRuntimeConfig(): Promise<RuntimeConfig> {
  const response = await fetch(`${API_URL}/api/config`);
  if (!response.ok) {
    throw new Error(`The server is not reachable (${response.status}).`);
  }
  return runtimeConfigSchema.parse(await response.json());
}
